import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShellComponent } from './components/shell/shell.component';
import { BannerExampleComponent } from './components/banner-example/banner-example.component';

const shellRoutes: Routes = [
  {
    path: '',
    component: ShellComponent,
    data: { title: 'Shell' },
    children: [
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomeModule),
        data: { title: 'WellSky DLS' },
      },
      {
        path: 'getting-started',
        loadChildren: () => import('../getting-started/getting-started.module').then(m => m.GettingStartedModule),
        data: { title: 'Components' },
      },
      {
        path: 'atlas-ui-migration',
        loadChildren: () => import('../atlas-ui-migration/atlas-ui-migration.module').then(m => m.AtlasUIMigrationModule),
        data: { title: 'Components' },
      },
      {
        path: 'components',
        loadChildren: () => import('../components/components.module').then(m => m.ComponentsModule),
        data: { title: 'Components' },
      },
      {
        path: 'utilities',
        loadChildren: () => import('../utilities/utilities.module').then(m => m.UtilitiesModule),
        data: { title: 'Utilities' },
      },
      {
        path: 'foundations',
        loadChildren: () => import('../foundations/foundations.module').then(m => m.FoundationsModule),
        data: { title: 'Foundations' },
      },
      {
        path: 'patterns',
        loadChildren: () => import('../patterns/patterns.module').then(m => m.PatternsModule),
        data: { title: 'Patterns' },
      },
      {
        path: 'faqs',
        loadChildren: () => import('../faqs/faqs.module').then(m => m.FAQsModule),
        data: { title: 'FAQs' },
      },
      {
        path: 'banner-example',
        component: BannerExampleComponent,
        data: { title: 'Banners' },
      },
      {
        path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(shellRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ShellRoutingModule { }
